import $ from 'jQuery';

global.$ = global.jQuery = $;

var isSP;
var _agent = navigator.userAgent.toLocaleLowerCase();
if (_agent.indexOf('iphone') > 0 || _agent.indexOf('android') > 0 && _agent.indexOf('mobile') > 0 || _agent.indexOf('ipad') > 0 || _agent.indexOf('android') > 0) {
  isSP = true;
}else {
  isSP = false;
}

var _event = {
  mousedown: isSP ? "touchstart" : "mousedown",
  mouseup: isSP ? "touchend" : "mouseup",
  mouseleave: isSP ? "touchmove" : "mouseleave"
};

var $window = $(window);
var $body = $("body");

//cards
var $card = $(".card");
var _isChoose = false;
var _isCurrent = false;

var $cardPersons = $(".card-person");
var cardBottomSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="650" height="272.01" viewBox="0 0 650 272.01" fill="#fff" opacity=".9"><path d="M166.12 262.23c-30.9-4.7-60.85-13.09-85.84-29.59C22.19 194.27 13.45 118 9.36 54.76Q7.61 27.43 6.1.06h636.46q-2.76 39.72-6.47 79.34c-3.39 36.45-7.55 75.56-25.68 108.16-16.76 30.14-45.07 50.55-77.36 61.95-42.44 15-89.83 17.64-134.46 20.12a1260.31 1260.31 0 01-143.49-.17c-28.1-1.6-58.98-2.67-88.98-7.23z" /></svg>';
var SetCardBottom = function(){
  $cardPersons.each(function(i){
    var _$this = $(this);
    var _color = _$this.data("color");
    var _$inner = _$this.find(".card-inner");
    var _$svgContainer = $("<div class='card--bottom card--wait'></div>");
    var _$svg = $(cardBottomSvg).css({fill: _color});
    _$svgContainer.append(_$svg);
    _$inner.prepend(_$svgContainer);
  });
};
SetCardBottom();

var CardSelect = function(tag){
  var _tag = tag;
  $card.each(function(){
    var _haveTag = false;
    var _$this = $(this);
    var _$inner = $(this).find(".card-inner");

    _$inner.removeClass("animation");

    var _tags = _$this.data("tags").split(",");
    for(var i = 0; i < _tags.length; i++){
      if(_tag === _tags[i]){
        _haveTag = true;
      }
    }
    if(_haveTag){
      _$this.css({display: ""});
      _$inner.addClass("wait");
    }else{
      _$this.css({display: "none"});
    }
  });

  Animation($(".cards-content"));

};

var CardReset = function(){
  _isChoose = false;
  $card.each(function(){
    var _$this = $(this);
    _$this.css({display: ""});
    _$this
      .find(".card-inner")
      .removeClass("animation")
      .addClass("wait");
  });
  $tag.each(function(){
    var _$this = $(this);
    if(_$this.hasClass("tag--current")){
      _$this.removeClass("tag--current");
    }
  });
  Animation($(".cards-content"));
};

//tags
var $tag = $(".tag");
var TagDown = function(event){
  var _$this = $(event.currentTarget);
  _$this.addClass("tag--down");
  _$this.on(_event.mouseup, TagUp);
  _$this.on(_event.mouseleave, TagMove);
};

var TagMove = function(event){
  var _$this = $(event.currentTarget);
  _$this.removeClass("tag--down");
  _$this.off(_event.mouseup, TagUp);
  _$this.off(_event.mouseleave, TagMove);
};

var TagUp = function(event){
  var _$this = $(event.currentTarget);

  if(_$this.hasClass("tag--current")){
    _isCurrent = true;
  }else{
    _isCurrent = false;
  }

  $tag.each(function(){
    var __$this = $(this);
    if(__$this.hasClass("tag--down")){
      __$this.addClass("tag--current");
    }else{
      __$this.removeClass("tag--current");
    }
  });

  CardContentAnimationReset();
  if(_isChoose && _isCurrent){
    CardReset();
  }else if(_$this.hasClass("tag--current")){
    CardSelect(_$this.data("tag"));
    _isChoose = true;
  }

  _$this.removeClass("tag--down");
  _$this.off(_event.mouseup, TagUp);
  _$this.off("mouseleave", TagUp);
};

$tag.on(_event.mousedown, TagDown);


//more
var $more = $("#more");
var $moreContent = $more.find(".cards-content");
var $moreBtn = $("#more_btn");
var MoreContentToggle = function(){
  if(!$more.hasClass("more--open")){
    $more.addClass("more--open");
    $moreContent.slideDown();
  }else{
    $more.removeClass("more--open");
    $moreContent.slideUp();
  }
};
$moreBtn.on("click", MoreContentToggle);


//persons
var $modalOpenPersons = $(".btn--person");
var $modal = $("#modal");
var $modalWrap = $("#modal_wrap");
var $modalContent = $modalWrap.find(".modal-person");
var $modalClose = $("#modal_close");
var $modalOverlay = $("#modal_overlay");

var ModalOpen = function(event){
  $modalWrap.addClass("modal-wrap--" + event.data.person);
  var _personClass = "modal-" + event.data.person;
  $modalContent.each(function(i){
    var _$this = $(this);
    if(!_$this.hasClass(_personClass)){
      _$this.css({display: "none"});
    }else{
      _$this.css({display: ""});
    }
  });


  $modalOverlay
    .removeClass()
    .css({display: "block"})
    .addClass(event.data.person);

  var _intervalSlideIn = setInterval(function(){
    $modalOverlay
      .addClass("slide-in");
    clearInterval(_intervalSlideIn);
  },10);

  var _intervalSlideOut = setInterval(function(){
    $modal.stop().animate({scrollTop: 0},0);
    $modalOverlay.addClass("slide-out-to-right");
    clearInterval(_intervalSlideOut);
  },700);


  var _intervalSlideClear = setInterval(function(){
    $modalOverlay
      .css({display: ""})
      .removeClass("slide-in")
      .removeClass("slide-out-to-right");
    clearInterval(_intervalSlideClear);
  },1200);


  $modal
    .css({display: "block", opacity: 0, overflow: ""})
    .stop()
    .delay(500)
    .animate({opacity: 1}, 0, function(){
      $body.addClass("is-modal");
      $modal.css({overflow: ""}).addClass("modal--open");
    });
  $modalClose.on("click", ModalClose);
  return false;
};

var ModalClose = function(){

  $modalOverlay.css({display: "block"});
  var _intervalSlideIn = setInterval(function(){
    $modalOverlay.addClass("slide-in");
    clearInterval(_intervalSlideIn);
  },10);

  var _intervalSlideOut = setInterval(function(){
    $modalOverlay.addClass("slide-out-to-right");
    $modal.css({overflow: "hidden"});
    $body.removeClass("is-modal");
    clearInterval(_intervalSlideOut);
  },700);

  var _intervalSlideClear = setInterval(function(){
    $modalOverlay
      .css({display: ""})
      .removeClass("slide-in")
      .removeClass("slide-out-to-right");
    clearInterval(_intervalSlideClear);
  },1200);


  $modal
    .stop()
    .delay(500)
    .animate({opacity: 0}, 0, function(){
      $modal.css({display: ""}).removeClass("modal--open");
      //$modalOpenPersons.css({display: ""});
      $modalWrap.removeClass();
    });
  $modalClose.off("click", ModalClose);
};

$modalOpenPersons.each(function(i){
  var _$this = $(this);
  _$this.on("click", {person: _$this.data("person")}, ModalOpen);
});

// movie
var $modalOpenMovie = $(".btn--movie");
var youtube = function(id){
  return '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + id + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
};
var $movieModal = $("#modal_movie");
var $movieModalContent = $("#modal_movie_content");
var $movieModalClose = $("#modal_movie_close");
var $movieModalOverlay = $("#modal_movie_overlay");

var MovieModalOpen = function(event){
  var _movieID = event.data.url;
  var _youtubeDOM = youtube(_movieID);

  $movieModal
    .css({display: "block", opacity: 0, "overflow-y": "hidden"})
    .stop()
    .animate({opacity: 1}, 400, function(){
      $movieModal.css({"overflow-y": ""}).addClass("modal--open");
      if($modal.css("display") !== "block"){
        $body.addClass("is-modal");
      }
    });

  $movieModalOverlay.css({display: "block"});
  $movieModalContent.append(_youtubeDOM);
  $movieModalClose.on("click", MovieModalClose);
  $movieModalOverlay.on("click", MovieModalClose);

  return false;
};

var MovieModalClose = function(){
  if($modal.css("display") !== "block"){
    $body.removeClass("is-modal");
  }
  $movieModalContent.empty();
  $movieModal
    .css({"overflow-y": "hidden"})
    .stop()
    .animate({opacity: 0}, 400, function(){
      $movieModal.css({display: ""}).removeClass("modal--open");
      $movieModalOverlay.css({display: ""});
    });

  $movieModalClose.off("click", MovieModalClose);
  $movieModalOverlay.off("click", MovieModalClose);
};

$modalOpenMovie.each(function(i){
  var _$this = $(this);
  _$this.on("click", {url: _$this.data("movie")}, MovieModalOpen);
});

var CloseBtnDown = function(event){
  var _$this = $(event.currentTarget);
  _$this.addClass("btn--down");
  _$this.on(_event.mouseup, CloseBtnUp);
  _$this.on("mouseleave", CloseBtnUp);
};

var CloseBtnUp = function(event){
  var _$this = $(event.currentTarget);
  _$this.removeClass("btn--down");
  _$this.off(_event.mouseup, CloseBtnUp);
  _$this.off("mouseleave", CloseBtnUp);
};

$modalClose.on(_event.mousedown, CloseBtnDown);
$movieModalClose.on(_event.mousedown, CloseBtnDown);

var BtnDown = function(event){
  var _$this = $(event.currentTarget);
  _$this.addClass("btn-popping--down");
  _$this.on(_event.mouseup, BtnUp);
  _$this.on("mouseleave", BtnUp);
};

var BtnUp = function(event){
  var _$this = $(event.currentTarget);
  _$this.removeClass("btn-popping--down");
  _$this.off(_event.mouseup, BtnUp);
  _$this.off("mouseleave", BtnUp);
};
$(".btn-popping").on(_event.mousedown, BtnDown);



var $bg = $("#bg");
var moveAmount = 0;
var BackgroundMoving = function(event){
  moveAmount = $window.scrollTop() * -.08;

  if($window.scrollTop() < 1){
    moveAmount = 0;
  }
  $bg.stop().animate({marginTop: moveAmount},1000);
};
//$window.on("scroll", BackgroundMoving);